import styled from "styled-components";

export const UserStatusCongratulationsBenefitsCardsListStyled = styled.div`
    padding: 16px 16px 0;   
    margin: 8px -16px 0;
    display: flex;
    gap: 8px;
    flex-wrap: nowrap;
    white-space: nowrap;
    overflow-x: auto;
    
    > *:first-child {
        margin-left: auto;
    }
    
    > *:last-child {
        margin-right: auto;
    }

    &.desktop {
        padding: 16px 0 0;
        margin: 8px 0 0;
        
        > *:first-child {
            margin-left: 0;
        }
        
        > *:last-child {
            margin-right: 0;
        }
    }
`;
